import React from 'react';

import * as S from './styles';

function Pencil() {
  return <S.Tipencil />;
}

export default Pencil;